import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import SelectionHeader from 'shared/ui/Table/cells/SelectionHeader';
import { allVulnsAreSelected, someVulnIsSelected } from 'store/ManageGeneral/selectors';
import { selectAllVulns } from 'store/ManageGeneral/actions';

const CheckHeaderVulnsGeneral = () => {
  const allVulnsSelected = useSelector(allVulnsAreSelected);
  const someVulnSelected = useSelector(someVulnIsSelected);
  const dispatch = useDispatch();
  const handleClick = () => {
    dispatch(selectAllVulns());
  };

  return (
    <SelectionHeader checked={ allVulnsSelected } indeterminate={ someVulnSelected && !allVulnsSelected } onChange={ handleClick } />
  );
};

export default CheckHeaderVulnsGeneral;
